import { ControllerFetchType } from "../../../helpers/fetchTypes";
import { useFetchStandardParagraphTypesQuery } from "../../../services/clientreports";
import FormSelect from "../FormSelect";

const StandardParagraphTypeSelect = ({
    value,
    setValue,
    isMulti = false,
    useOnChange = false,
    ...rest
}) => {
    const { data, isFetching } = useFetchStandardParagraphTypesQuery({ fetchType: ControllerFetchType.List });
    const { results: options } = data || { results: [] };

    const handleChange = (selection) => isMulti
        ? setValue(selection.map(s => s.value))
        : setValue(selection.value);

    return <FormSelect
        {...rest}
        defaultValue={value}
        onChange={useOnChange ? handleChange : null}
        onBlur={useOnChange ? null : handleChange}
        options={options}
        isLoadingOptions={isFetching}
        isMulti={isMulti}
    />
}

export default StandardParagraphTypeSelect;